//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import hsbCorrection from "apis/hsbPointsCorrection/hsbPointsCorrection";

import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useTranslation } from 'react-i18next';
import { dateAndTimeFormat } from "helpers/dataFormat"

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function ViewShipTo(props) {
  const { state, dispatch } = useContext(Context);
  const { gethsbCorrectionDetail } = hsbCorrection();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const {t,i18n}=useTranslation()

  // setting mpc details
  // useEffect(() => {
  //   if (location.state && location.state.mpc) {
  //     setMpc(location.state.mpc);
  //     return;
  //   } else {
  //     history.goBack();
  //   }
  // }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "HSb Correction"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.mpcId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);
  const pointsFormat = (value) => {
    if (value) {
      var nfObject = new Intl.NumberFormat("en-US");
      var points = nfObject.format(value);
      return points;
    }
    return "";
  };
  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.mpcId;
      let res = await gethsbCorrectionDetail(id);
      if (res) {
        setData(res?.data[0]);
        setDataClone(res?.data[0]);
      }
    } catch (e) {
      console.log({ e });
    }
  };

 



  
  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/hsb-points-correction", { offset });
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
        <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('HSB Correction')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Loyalty Id')}</span> :{" "}
            {data.loyalty_id}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Billto')}</span> :{" "}
            {data.customer_billto_account_number}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Shipto')}</span> :{" "}
            {data.customer_account_number}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              {t('Old Points')}
            </span>{" "}
            : {pointsFormat(data.points)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('New Points')}</span> :{" "}
            {pointsFormat(data.New_points)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              {t('Difference Points')}
            </span>{" "}
            : {pointsFormat(data.difference)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Old Rule ID')}</span> :{" "}
            {data.old_rule_id}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
             {t('Old Rule Description')}
            </span>{" "}
            : {data.old_rule_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('New Rule ID')}</span> :{" "}
            {t(data.new_rule_id)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('New Rule Description')}</span> :{" "}
            {t(data.new_rule_description)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Sales Amount')}</span> :{" "}
            {t(data.extended_sales_amount)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('New Multiplier')}</span> :{" "}
            {t(data.new_multiplier)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Order Number')}</span> :{" "}
            {t(data.order_number)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Order ID')}</span> :{" "}
            {t(data.order_id)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Order Line Number')}</span> :{" "}
            {t(data.order_line_number)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Updated ON')}</span> :{" "}
            {dateAndTimeFormat(data.updated_on, i18n.language)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Reason')}</span> :{" "}
            {t(data.reason_code)}
          </div>
        </Grid>
      </Grid>

    </React.Fragment>
  );
}
